export default {
  main: {
    fontWeight: 'bold',
    textTransform: 'uppercase',
    fontFamily: 'Open Sans Condensed',
  },
}
